import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";

import row1 from "./data/row1.json";
import row2 from "./data/row2.json";
import row3 from "./data/row3.json";
import row4 from "./data/row4.json";
import row5 from "./data/row5.json";
import row6 from "./data/row6.json";

import health from "./img/icon-healthcare.svg";
import retail from "./img/icon-retail.svg";
import education from "./img/icon-highered.svg";
import whiteE from "./img/white-e.svg";
import "./App.scss";
import "./css/animate.css";
const options = [
  { value: "open", label: "Open Ecosystem", color: "#5b5860" },
  { value: "security", label: "Security", color: "#e2b100" },
  { value: "ai", label: "AI/Machine Learning", color: "#e57123" },
  { value: "automation", label: "Automation", color: "#00a5bf" },
  { value: "analytics", label: "Analytics & Insight", color: "#66bc53" },
  { value: "services", label: "Services & Support", color: "#643da3" },
  { value: "sd", label: "SD Infrastructure", color: "#c3025f" }
];
const dot = (color = "#ccc") => ({
  alignItems: "center",
  display: "flex",

  ":before": {
    backgroundColor: color,
    borderRadius: 3,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10
  }
});
const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? data.color
        : isFocused
        ? data.color
        : null,
      color: isDisabled
        ? null
        : isSelected
        ? "#fff"
        : isFocused
        ? "#fff"
        : "#000",
      cursor: isDisabled ? "not-allowed" : "default"
    };
  },
  input: styles => ({ ...styles, ...dot() }),
  placeholder: styles => ({ ...styles, ...dot() }),
  singleValue: (styles, { data }) => ({
    ...styles,
    ...dot(data.color)
  })
};
class PeriodicTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logoState: "bounceInUp",
      elementAnimation: "zoomInDown",
      buttonState: "flipInX",
      startExplore: true,
      moveElement: "unmoved",
      row1: row1.row1,
      row2: row2.row2,
      row3: row3.row3,
      row4: row4.row4,
      row5: row5.row5,
      row6: row6.row6,
      selectedColor: "",
      hideTable: false,
      filterSelect: "open"
    };

    this.selectElement = this.selectElement.bind(this);
  }

  startExplore() {
    this.setState({
      logoState: "bounceOutDown",
      buttonState: "bounceOutDown"
    });
    setTimeout(() => {
      this.setState({
        startExplore: false
      });
    }, 950);
  }

  moveElement() {
    this.setState({
      moveElement: "moved"
    });
  }
  selectElement(e) {
    e.preventDefault();
    this.setState({
      selectedColor: e.target.dataset.color
    });
    console.log(this.state.selectedColor);
  }
  selectCategory(e) {
    e.preventDefault();
    this.setState({ vertical: e.target.dataset.category });
    console.log(this.state.vertical);
  }
  _onChange(value) {
    //console.log(value) - just to see what we recive from <Select />
    this.setState({ filterSelect: value.value });
    if (this.state.hideTable === true) {
      this.setState({ hideTable: false });
    }
  }
  render() {
    return (
      <div>
        <Select
          defaultValue={options[0]}
          options={options}
          className="dropdown"
          styles={colourStyles}
          onChange={this._onChange.bind(this)}
          isSearchable={false}
        />

        <div
          className={
            this.state.hideTable === true
              ? "animated fadeOut"
              : " fasterAnimate animated fadeIn"
          }
        >
          <div className="elementsContainer periodicTable">
            <Link
              to={{
                pathname: "/element",
                state: {
                  selectedColor: "purp",
                  selectedabbv: "Hu",
                  selectedLabel: "Human",
                  selectedTitle: "The Human Element",
                  selectedContent:
                    "<h3 class='human'>Getting networking right means putting people first</h3><ul><li>People are the foundation of our relentless commitment to building networks that accelerate your digital transformation.</li><li>Make sure yours – customers, employees, partners – get what they need, when and where they need it most.</li><li>Deliver powerful new human experiences through customer-driven networking.</li></ul>",
                  selectedUrl: ""
                }
              }}
            >
              <div className="humanElement animated flipInX">
                <img src={whiteE} className="cornerLogo" />
                <h3 className="elementAbbv">Hu</h3>
                <h3 className="elementName">Human</h3>
              </div>
            </Link>

            <div className="elementsRow">
              {this.state.row1.map((item, i) => (
                <Link
                  className={
                    "element animated zoomInDown " +
                    item.color +
                    "  animate" +
                    i +
                    " flipInX filter filter" +
                    item.color +
                    this.state.filterSelect
                  }
                  key={i}
                  data-color={item.color}
                  to={{
                    pathname: "/element",
                    state: {
                      selectedColor: item.color,
                      selectedabbv: item.abbreviation,
                      selectedLabel: item.label,
                      selectedTitle: item.title,
                      selectedContent: item.content,
                      selectedBack: "/table",
                      selectedUrl: item.url
                    }
                  }}
                >
                  {item.color === "darkGray" ? (
                    <span className="partnerP">P</span>
                  ) : (
                    <img src={whiteE} className="cornerLogo" />
                  )}
                  <h3 className="elementAbbv">{item.abbreviation}</h3>
                  <h3 className="elementName">{item.label}</h3>
                </Link>
              ))}
            </div>

            <div className="elementsRow">
              {this.state.row2.map((item, i) => (
                <Link
                  className={
                    "element animated zoomInDown " +
                    item.color +
                    "  animate" +
                    i +
                    " flipInX filter filter" +
                    item.color +
                    this.state.filterSelect
                  }
                  key={i}
                  data-color={item.color}
                  to={{
                    pathname: "/element",
                    state: {
                      selectedColor: item.color,
                      selectedabbv: item.abbreviation,
                      selectedLabel: item.label,
                      selectedTitle: item.title,
                      selectedContent: item.content,
                      selectedBack: "/table",
                      selectedUrl: item.url
                    }
                  }}
                >
                  {item.color === "darkGray" ? (
                    <span className="partnerP">P</span>
                  ) : (
                    <img src={whiteE} className="cornerLogo" />
                  )}
                  <h3 className="elementAbbv">{item.abbreviation}</h3>
                  <h3 className="elementName">{item.label}</h3>
                </Link>
              ))}
            </div>

            <div className="elementsRow">
              {this.state.row3.map((item, i) => (
                <Link
                  className={
                    "element animated zoomInDown " +
                    item.color +
                    "  animate" +
                    i +
                    " flipInX filter filter" +
                    item.color +
                    this.state.filterSelect
                  }
                  key={i}
                  data-color={item.color}
                  to={{
                    pathname: "/element",
                    state: {
                      selectedColor: item.color,
                      selectedabbv: item.abbreviation,
                      selectedLabel: item.label,
                      selectedTitle: item.title,
                      selectedContent: item.content,
                      selectedBack: "/table",
                      selectedUrl: item.url
                    }
                  }}
                >
                  {item.color === "darkGray" ? (
                    <span className="partnerP">P</span>
                  ) : (
                    <img src={whiteE} className="cornerLogo" />
                  )}
                  <h3 className="elementAbbv">{item.abbreviation}</h3>
                  <h3 className="elementName">{item.label}</h3>
                </Link>
              ))}
            </div>

            <div className="elementsRow">
              {this.state.row4.map((item, i) => (
                <Link
                  className={
                    "element animated zoomInDown " +
                    item.color +
                    "  animate" +
                    i +
                    " flipInX filter filter" +
                    item.color +
                    this.state.filterSelect
                  }
                  key={i}
                  data-color={item.color}
                  to={{
                    pathname: "/element",
                    state: {
                      selectedColor: item.color,
                      selectedabbv: item.abbreviation,
                      selectedLabel: item.label,
                      selectedTitle: item.title,
                      selectedContent: item.content,
                      selectedBack: "/table",
                      selectedUrl: item.url
                    }
                  }}
                >
                  {item.color === "darkGray" ? (
                    <span className="partnerP">P</span>
                  ) : (
                    <img src={whiteE} className="cornerLogo" />
                  )}
                  <h3 className="elementAbbv">{item.abbreviation}</h3>
                  <h3 className="elementName">{item.label}</h3>
                </Link>
              ))}
            </div>

            <div className="elementsRow">
              {this.state.row5.map((item, i) => (
                <Link
                  className={
                    "element animated zoomInDown " +
                    item.color +
                    "  animate" +
                    i +
                    " flipInX filter filter" +
                    item.color +
                    this.state.filterSelect
                  }
                  key={i}
                  data-color={item.color}
                  to={{
                    pathname: "/element",
                    state: {
                      selectedColor: item.color,
                      selectedabbv: item.abbreviation,
                      selectedLabel: item.label,
                      selectedTitle: item.title,
                      selectedContent: item.content,
                      selectedBack: "/table",
                      selectedUrl: item.url
                    }
                  }}
                >
                  {item.color === "darkGray" ? (
                    <span className="partnerP">P</span>
                  ) : (
                    <img src={whiteE} className="cornerLogo" />
                  )}
                  <h3 className="elementAbbv">{item.abbreviation}</h3>
                  <h3 className="elementName">{item.label}</h3>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PeriodicTable;
